const Emerald = {
  Emerald: {
    _000: '#ECFDF5',
    _100: '#D1FAE5',
    _200: '#A7F3D0',
    _300: '#6EE7B7',
    _400: '#34D399',
    _500: '#10B981',
    _600: '#059669',
    _700: '#047857',
    _800: '#065F46',
    _900: '#064E3B',
  },
};

export default Emerald;
